
const Tab = (props:any)=>{
   
    const handleClick = ()=>{
        props.onSelect(props.id)
    }
    const active = props.active ? "bg-accent text-white":"";
    return <div className={`mb-0 mx-0 border border-b-0 rounded-t-md px-4 py-2 cursor-pointer hover:bg-primaryLight ${active}`} onClick={handleClick}>{props.title}</div>
}
export default Tab;